import { THEME_KEY, CUSTOM_KEY, type CustomMap } from "./themeConstants";

export function readPreset(): string {
  if (typeof window === "undefined") return "";
  try { return localStorage.getItem(THEME_KEY) ?? ""; } catch { return ""; }
}

export function writePreset(id: string) {
  if (typeof window === "undefined") return;
  try { localStorage.setItem(THEME_KEY, id); } catch {}
}

export function readCustom(): CustomMap {
  if (typeof window === "undefined") return {};
  try { return JSON.parse(localStorage.getItem(CUSTOM_KEY) ?? "{}"); } catch { return {}; }
}

export function writeCustom(map: CustomMap) {
  if (typeof window === "undefined") return;
  try { localStorage.setItem(CUSTOM_KEY, JSON.stringify(map)); } catch {}
}
